(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kj-cookies"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href$="#gerer-cookies"]');
      if (!link) return;
      event.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kj-shop-text"] && !Shopify.designMode) return;
  try {
    /* Accordéon « un seul volet ouvert » (fiche produit, 2026-10-07).
     Posé via « Classe additionnelle » = kj-acc-single sur un bloc Accordéons natif.
     Le bloc natif rend des <details> indépendants : quand un volet s'ouvre, on referme les
     autres volets du même accordéon. Aucun fichier vendor modifié. */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    var group = details.closest('.kj-acc-single');
    if (!group) return;
    group.querySelectorAll('details[open]').forEach(function (other) {
      if (other !== details && other.closest('.kj-acc-single') === group) other.open = false;
    });
  }, true);

  /* Toujours un volet ouvert : un clic sur le titre du volet déjà ouvert ne le referme pas. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    if (details.closest('.kj-acc-single')) event.preventDefault();
  }, true);
  /* Prix du bouton d'achat selon l'option d'achat Seal (demande Joachim 21/10/2026 18h57).
     Le thème affiche toujours le prix « achat unique » dans « Ajouter au panier | 8€ », même
     quand le client choisit « Recevoir chaque mois » ou change de fréquence. Ici : on lit le
     plan choisi dans le champ caché selling_plan que Seal remplit, on prend son prix dans les
     données Shopify de la fiche (/products/<handle>.js, selling_plan_allocations) et on
     l'écrit dans le prix du bouton (et de la barre d'achat fixe), ainsi que le prix au kilo
     « Soit … / kg » (unit_price du plan, 21/10 19h01). Aucun fichier vendor modifié ;
     sans widget Seal sur la page, rien ne se passe. */
  (function () {
    var data = null, loading = false, timer = null;
    function fmt(c) { return c % 100 === 0 ? (c / 100) + '€' : (c / 100).toFixed(2).replace('.', ',') + '€'; }
    function sealForm() {
      var w = document.querySelector('form[action*="/cart/add"] .sealsubs-target-element');
      return w ? w.closest('form') : null;
    }
    function sync() {
      var form = sealForm(); if (!form) return;
      if (!data) {
        var m = location.pathname.match(/\/products\/[^\/?#]+/);
        if (!m || loading) return;
        loading = true;
        fetch(m[0] + '.js').then(function (r) { return r.json(); }).then(function (j) { data = j; sync(); }).catch(function () {});
        return;
      }
      var idInput = form.querySelector('[name="id"]'), sp = form.querySelector('input[name="selling_plan"]');
      if (!idInput) return;
      var v = null;
      for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === String(idInput.value)) v = data.variants[i];
      if (!v) return;
      var price = v.price, unit = v.unit_price;
      if (sp && sp.value) {
        (v.selling_plan_allocations || []).forEach(function (a) {
          if (String(a.selling_plan_id) === String(sp.value)) { price = a.price; if (a.unit_price != null) unit = a.unit_price; }
        });
      }
      var txt = fmt(price);
      var targets = [].slice.call(form.querySelectorAll('[data-ref="add-to-cart-button-container"] .price[data-ref="price"]'))
        .concat([].slice.call(document.querySelectorAll('sticky-add-to-cart .price[data-ref="price"]')));
      targets.forEach(function (el) {
        if (el.textContent.trim() !== txt) { el.textContent = txt; el.setAttribute('data-value', price); }
      });
      if (unit == null) return;
      var root = form.closest('.shopify-section') || document;
      [].slice.call(root.querySelectorAll('.unit-price[data-ref="unit-price"]')).forEach(function (el) {
        var t = el.textContent, i = t.indexOf('€');
        if (i < 0) return;
        var nt = fmt(unit) + t.slice(i + 1);
        if (t !== nt) el.textContent = nt;
      });
    }
    function later() { clearTimeout(timer); timer = setTimeout(sync, 60); setTimeout(sync, 400); }
    document.addEventListener('change', later, true);
    document.addEventListener('click', later, true);
    document.addEventListener('keyup', later, true);
    function watch() {
      var form = document.querySelector('form.product-form__form[action*="/cart/add"]');
      if (!form || !window.MutationObserver) return;
      var mo = new MutationObserver(later);
      mo.observe(form.closest('.shopify-section') || form, { childList: true, subtree: true, characterData: true });
      var st = document.querySelector('sticky-add-to-cart');
      if (st) mo.observe(st, { childList: true, subtree: true, characterData: true });
      later();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  })();
  } catch(e) { console.error(e); }
})();

})();
